export default __webpack_public_path__ + "static/media/degree.52a9df0e.png";